import { render } from "./VolForm.vue?vue&type=template&id=36cd2a29&scoped=true"
import script from "./VolForm.vue?vue&type=script&lang=js"
export * from "./VolForm.vue?vue&type=script&lang=js"

import "./VolForm.vue?vue&type=style&index=0&id=36cd2a29&lang=less&scoped=true"
import "./VolForm.vue?vue&type=style&index=1&id=36cd2a29&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36cd2a29"]])

export default __exports__